import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Box, CircularProgress } from '@mui/material'
import Layout from './components/Layout'
import Header from './components/Header'
import Dashboard from './pages/Dashboard'
import Landing from './pages/Landing'
import AccessDenied from './components/AccessDenied'
import { useWallet } from './hooks/useWallet'
import { ConnectionStatus } from './constants/connectionStatus'
import { useTheme } from './contexts/ThemeContext'

function AppContent() {
  const { status, isAdmin, isCheckingAdmin } = useWallet()
  const isConnected = status === ConnectionStatus.Connected
  const { colors } = useTheme()

  if (isConnected && isCheckingAdmin) {
    return (
      <Layout>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 'calc(100vh - 100px)',
          }}
        >
          <Box sx={{ textAlign: 'center' }}>
            <CircularProgress
              sx={{
                color: colors.primary,
                mb: 2,
              }}
              size={60}
            />
          </Box>
        </Box>
      </Layout>
    )
  }

  if (isConnected && !isAdmin && !isCheckingAdmin) {
    return (
      <Layout>
        <AccessDenied />
      </Layout>
    )
  }

  return (
    <Layout>
      {isConnected && isAdmin && <Header />}
      <Routes>
        <Route
          path="/"
          element={isConnected && isAdmin ? <Dashboard /> : <Landing />}
        />
      </Routes>
    </Layout>
  )
}

function App() {
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <AppContent />
    </Router>
  )
}

export default App
